export default "__VITE_ASSET__CY_sVI1V__"